import { render, staticRenderFns } from "./list-modules.vue?vue&type=template&id=5f52d9a7"
import script from "./list-modules.vue?vue&type=script&lang=js"
export * from "./list-modules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports